import { RouterProvider } from "react-router-dom";

import { router } from "./router";
import { AuthProvider } from "./context";
import ThemeProvider from "./theme/ThemeProvider";
import { AnalyticsProvider } from "./services/analytics/AnalyticsProvider";
import { OfflineBanner, ReloadPrompt } from "@components";
import { useOnlineStatus } from "@hooks";

function App() {
  const isOnline = useOnlineStatus();

  return (
    <ThemeProvider>
      {!isOnline && <OfflineBanner />}
      <ReloadPrompt />
      <AuthProvider>
        <AnalyticsProvider>
          <RouterProvider router={router} />
        </AnalyticsProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
